<template>
  <LineChart
    :chart-data="data"
    :options="options"
    css-classes="chart-container"
  />
</template>

<script setup>
import { ref, computed } from "vue";
import { LineChart } from "vue-chart-3";
import {
  Chart,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
Chart.register(
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
);
const toggleLegend = ref(true);

const data = computed(() => ({
  labels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  datasets: [
    {
      label: "Earnings",
      data: [200, 200, 500, 100, 200, 500, 200, 500, 700, 300, 600, 1000],
      borderColor: "#A060EB",
      backgroundColor: "#A060EB",
      fill: false,
      // tension: 0.1,
    },
  ],
}));
const options = ref({
  plugins: {
    legend: {
      display: false,
      position: toggleLegend.value ? "bottom" : "bottom",
      align: "start",
      fullSize: true,
    },
    title: {
      display: false,
      text: "Chart.js Doughnut Chart",
    },
  },
});
</script>


<style lang="scss" scoped>
h2 {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 2rem;
}
ul {
  li {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 1rem;
    span {
      display: inline-block;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin: 0 1rem 0 0.5rem;
      &.case-1 {
        background-color: #7d00a9;
      }
      &.case-2 {
        background-color: #a060eb;
      }
    }
  }
}
</style>